import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fourBySixTab: {
    description: 'tab to select 4x6 label layout',
    defaultMessage: '4" X 6"',
    id: '6nyzJJ',
  },
  eightByElevenTab: {
    description: 'tab to select 8.5x11 label layout',
    defaultMessage: '8.5" X 11"',
    id: 'glFADV',
  },
  aFourTab: {
    description: 'tab to select A4 label layout',
    defaultMessage: 'A4',
    id: '3EfwHh',
  },
  aSixTab: {
    description: 'tab to select A6 label layout',
    defaultMessage: 'A6',
    id: 'vSP3NK',
  },
  customTab: {
    description: 'tab to select Custom label layout',
    defaultMessage: 'Custom',
    id: 'ETU6Rc',
  },
  fourBySixTitle: {
    description: 'title to select 4x6 label layout',
    defaultMessage: '4" x 6"',
    id: 'ywVFSD',
  },
  fourBySixWithPackingSlipTitle: {
    description: 'title to select 4x6 with packing slip label layout',
    defaultMessage: '4" x 6" + Packing Slip',
    id: 'RsKh4S',
  },
  eightByElevenTitle: {
    description: 'title to select 8.5x11 label layout',
    defaultMessage: '8.5" x 11"',
    id: 'lDKg5E',
  },
  eightByElevenWithPackingSlipTitle: {
    description: 'title to select 8.5x11 with packing slip label layout',
    defaultMessage: '8.5" x 11" + Packing Slip',
    id: 'kY4Nx1',
  },
  aFourTitle: {
    description: 'title to select A4 label layout',
    defaultMessage: 'A4 Label only',
    id: 'lYxfpy',
  },
  aFourWithPackingSlipTitle: {
    description: 'title to select A4 with packing slip label layout',
    defaultMessage: 'A4 + Packing Slip',
    id: 'm3NBGI',
  },
  aSixTitle: {
    description: 'title to select A6 label layout',
    defaultMessage: 'A6 Label only',
    id: 'RQiiKb',
  },
  aSixWithPackingSlipTitle: {
    description: 'title to select A6 with packing slip label layout',
    defaultMessage: 'A6 + Packing Slip',
    id: 'I6fiWM',
  },
  labelPrinterDescription: {
    description: 'description to select label printer layout',
    defaultMessage: 'Label Printer - Zebra, Dymo, etc.',
    id: 'pte3U0',
  },
  traditionalPrinterDescription: {
    description: 'description to select traditional label layout',
    defaultMessage: 'Traditional Printer - Laser, Inkjet, etc',
    id: 'l1lw9J',
  },
  eCom2Blanks: {
    description: 'Label format eCom with label and 2 blank panels',
    defaultMessage: 'eCom (w/ Label & 2 Blank Panels)',
    id: 'uR/2xn',
  },
  eComPanel2: {
    description: 'Label format eCom with label then packing slip then blank panel',
    defaultMessage: 'eCom (w/ Label, Packing Slip & Blank Panel)',
    id: 'rNdRRr',
  },
  eComPanel3: {
    description: 'Label format eCom with label then blank panel then packing slip ',
    defaultMessage: 'eCom (w/ Label, Blank Panel & Packing Slip)',
    id: '0pTw6w',
  },
  label4x6: {
    description: 'Label format 4x6',
    defaultMessage: '4" x 6" (Thermal Shipping Label)',
    id: 'cFLdiE',
  },
  labelWithPackingSlip4x6: {
    description: 'Label format 4x6 with packing slip',
    defaultMessage: '4" x 6" (w/ Packing Slip)',
    id: 'jSupdd',
  },
  labelLetter: {
    description: 'Label format letter',
    defaultMessage: '8.5" x 11" (2 per page)',
    id: 'H/AGtQ',
  },
  labelWithPackingSlipLetter: {
    description: 'Label format letter with packing slip',
    defaultMessage: '8.5" x 11" (w/ Packing Slip)',
    id: 'vorIwp',
  },
});
